// Import utils
import { getDocumentElements, getDocumentElement, updateFieldTotal } from "../../Utils/Utils";

/**
 * Callback function to execute when mutations are observed. This will
 * only fire the calculation if we notice a change in the childlist nodes.
 * 
 * @param       {array}     mutationList
 * 
 * @returns     {void}
 */
const GroundwaterCreeksRiversCalcChildNodeObserver = (mutationList) => {
    mutationList.forEach(mutation => {
        if (mutation.type === "childList") {
            GroundwaterCreeksRiversCalc(true);
        }
    });
};

/**
 * Set the childlist mutation observer.
 * 
 * @returns     {void}
 */
const SetGroundwaterCreeksRiversCalcMutationObserver = () => {
    const Accordion = getDocumentElement('#groundwater-creeks-and-rivers');
    const ObserverConfig = { childList: true, subtree: true };

    const Observer = new MutationObserver(GroundwaterCreeksRiversCalcChildNodeObserver);
    Observer.observe(Accordion, ObserverConfig);
};

/**
 * This watches the sub total fields for value changes. It calls for an update
 * on the total water supply. If we have already mounted the eventlisteners, ignore
 * the mutationobserver setup.
 * 
 * @param       {boolean}   mounted
 * 
 * @returns     {void}
 */
export const GroundwaterCreeksRiversCalc = (mounted) => {
    const SupplyTotalField = getDocumentElement('#supplyTotal');
    const SupplySummaryTotalField = getDocumentElement('#tot_supply_type');
    const SupplyMegaLFields = getDocumentElements('#groundwater-creeks-and-rivers [id^="supplyPerYear"]');

    if (SupplyMegaLFields && SupplyTotalField) {
        if (mounted === false) {
            SetGroundwaterCreeksRiversCalcMutationObserver();
        }

        SupplyMegaLFields.forEach(field => {
            field.addEventListener('input', e => {
                e.stopImmediatePropagation();

                updateFieldTotal(SupplyMegaLFields, SupplyTotalField, SupplySummaryTotalField);
            });
        });
    }

    // listen for clone removed and re-update totals
    document.addEventListener('clonable:removed', e => {
        if (e.detail.id === 'supply') {
            updateFieldTotal(SupplyMegaLFields, SupplyTotalField, SupplySummaryTotalField);
        }
    });
};
